/*
 * Copyright (c) 2022-2024. Haodong JU
 */

import hillo from 'hillo'
import GlobalSettings from '@/model/global/GlobalSettings'
import { storageGet, storageNewApiHost, storagePost } from '@/model/dataLayer/api/storage/inventoryUtils'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'

export async function getRealADI () {
  return { params: { ADI: GlobalSettings.DeviceId } }
}

export async function getDishConsumptionList (dishType = 1) {
  return await storageGet('consumption/listByShopId/' +
    await getCurrentDeviceId(), {})
}

export async function clearAllLogs () {
  return (await hillo.jsonPost(storageNewApiHost + 'resourceLog/' + 'deleteAll',
    {}, await getRealADI())).data
}

export async function setDishConsumption (dishId,
  dishType,
  resourceId,
  unitId,
  consumption) {
  return await storagePost('consumption/save', {
    dishId,
    dishType,
    resourceId,
    unitId,
    consumption
  })
}

export async function deleteDishConsumption (id) {
  return await storagePost('consumption/delete/' + id, {})
}

export async function checkCloudResourceTrack () {
  return (await hillo.post('Dishes.php?op=checkCloudResourceTrack', {})).content.enabled
}
